
import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";

import { SubStepTypeEnum } from "../utils/constants";

const radioButtons = [
   {
      label: "Cooking Notes:",
      value: SubStepTypeEnum.OUTSIDE_INSTRUCTION
   },
   {
      label: "Instructions",
      value: SubStepTypeEnum.INSTRUCTION
   },
   {
      label: "Add Ingredients List",
      value: SubStepTypeEnum.INGREDIENTS
   },
]

const SubStepTypeSelector = ({ instructionType, setInstructionType }: { instructionType: string, setInstructionType: React.Dispatch<React.SetStateAction<string>> }) => (<FormControl>
   <RadioGroup
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => setInstructionType(event.target.value)}
      value={instructionType}
   >
      {radioButtons.map((element) =>
         <FormControlLabel control={<Radio />} label={<Typography color='#9F9F9F' variant="caption3Light">{element.label}</Typography>} value={element.value} />
      )}
   </RadioGroup>
</FormControl>
);

export default SubStepTypeSelector;